import { render, staticRenderFns } from "./DodEmptyList.vue?vue&type=template&id=5cc7a429&scoped=true&"
import script from "./DodEmptyList.vue?vue&type=script&lang=js&"
export * from "./DodEmptyList.vue?vue&type=script&lang=js&"
import style0 from "./DodEmptyList.vue?vue&type=style&index=0&id=5cc7a429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7a429",
  null
  
)

export default component.exports